import { useState } from "react";

interface IntroProps {
  organizationName: string;
  organizationLogoUrl: string | null;
  onContinue: () => void;
}

export function Intro({ organizationName, organizationLogoUrl, onContinue }: IntroProps) {
  const [orgLogoFailed, setOrgLogoFailed] = useState(false);
  const showOrgLogo = organizationLogoUrl && !orgLogoFailed;

  return (
    <div>
      <div className="flex items-center justify-center gap-3">
        <img
          src="/seedlink-icon.svg"
          alt="SeedLink"
          className="w-12 h-12 rounded-full border border-gray-200"
        />
        {showOrgLogo ? (
          <img
            src={organizationLogoUrl}
            alt={organizationName}
            onError={() => setOrgLogoFailed(true)}
            className="w-12 h-12 rounded-full border border-gray-200 object-cover"
          />
        ) : (
          <div
            className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-700 text-white text-lg font-semibold"
            aria-hidden="true"
          >
            {organizationName.charAt(0).toUpperCase()}
          </div>
        )}
      </div>

      <h1 className="mt-4 text-base font-semibold text-gray-900 text-center">
        {organizationName} uses SeedLink to Connect with your seed-to-sale tracking provider
      </h1>

      <button
        type="button"
        onClick={onContinue}
        className="mt-6 w-full py-2.5 bg-gray-900 text-white text-sm font-medium hover:bg-gray-800"
      >
        Continue
      </button>
    </div>
  );
}
